import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AEMErrorMessagesSection,
  CommonConstants,
  EndpointKeys,
  getUniqueIdentifier,
  IDP_APPS,
  Libraries
} from '@com-delta-idp/mnx-skymiles-shared';
import {
  ApiBuilder,
  AppConfigService,
  handleError,
  HttpHeadersPayload,
  HttpRequestMethods
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';

import { SessionService } from '@com-delta-idp/mnx-oauth';
import {
  PartnersPromotionsRequest,
  PartnersPromotionsResponse
} from '../models/partners-promotions.interfaces';
import { Params } from '../models/partners.constants';

@Injectable({
  providedIn: 'root'
})
export class PartnersPromotionsService {
  errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private session: SessionService
  ) {}

  getPartnersPromotionsContent = (
    request: PartnersPromotionsRequest
  ): Observable<PartnersPromotionsResponse> => {
    const headerInfo: HttpHeadersPayload = {
      'Content-Type': Params.CONTENT_TYPE,
      transactionId: getUniqueIdentifier(),
      channelId: Params.CHANNEL_ID,
      'X-Delta-DLCOM_Loyalty_App_Test': Params.CUSTOM_HEADER,
      authorization: this.session.token.access_token
    };
    return new ApiBuilder<
      PartnersPromotionsRequest,
      PartnersPromotionsResponse
    >(this.http, this.appConfig)
      .app(IDP_APPS.SKYMILES)
      .endpointKey(EndpointKeys['SKYMILES_API_PARTNERS_PROMOTIONS'])
      .method(HttpRequestMethods['POST'])
      .payload(request)
      .httpHeaders(headerInfo)
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(handleError.bind(this))
      .library(Libraries.PARTNERS)
      .create();
  };

  getErrorMessages = (): Observable<AEMErrorMessagesSection> =>
    new ApiBuilder<undefined, AEMErrorMessagesSection>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.SKYMILES)
      .endpointKey(EndpointKeys['SKYMILES_AEM_PARTNERS_ERROR_MESSAGES'])
      .method(HttpRequestMethods['GET'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(Libraries.LANDING_PAGE)
      .create();
}
